<app-header *ngIf="!flagApp"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-modal></app-modal>
<app-loading></app-loading>
<app-suscripcion></app-suscripcion>
<app-chat-datina *ngIf="!flagPagos"></app-chat-datina>